import { render, staticRenderFns } from "./ContentClickAction.vue?vue&type=template&id=c67d636a&"
import script from "./ContentClickAction.vue?vue&type=script&lang=js&"
export * from "./ContentClickAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports